import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { PlanogramComponent } from '../pages/planogram/planogram.component';
import { LayoutService } from '../services/layout.service';
import { DialogService } from '../services/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<PlanogramComponent> {
  constructor(
    private layoutService: LayoutService,
    private dialogService: DialogService
  ) {}

  async canDeactivate(): Promise<boolean> {
    if (this.layoutService.canUndo()) {
      return await this.dialogService.showConfirmation(
        'Unsaved Changes',
        'You have unsaved changes in your planogram. Are you sure you want to leave without saving?'
      );
    }
    return true;
  }
}